import { action, computed, makeAutoObservable } from 'mobx';
import { apiCommon } from 'src/api/ApiCommon';
import { CmsTranslationDataModelType } from 'src/api/config/cmsTranslations/getAllCmsTranslations';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { ParamsType } from 'src/api_openapi/generated/openapi_website_cms_createCmsTranslation';
import { TranslationFormType } from '../HomePageCarouselState/HomePageCarouselState';

type CmsTranslationFormBodyType = ParamsType['body'];

export class CmsTranslationsState {
    public readonly translationsResource: Resource<Array<CmsTranslationDataModelType>>;

    constructor() {
        this.translationsResource = new Resource(async (): Promise<Array<CmsTranslationDataModelType>> => {
            return await apiCommon.getAllCmsTranslations.run({});
        });
        makeAutoObservable(this);
    }

    @computed get cmsTranslationsList(): Array<CmsTranslationDataModelType> {
        const resource = this.translationsResource.get();

        if (resource.type === 'ready') {
            return resource.value;
        }

        return [];
    }

    @action public handleCreateApiCall = async (
        cmsTranslationForm: CmsTranslationFormBodyType
    ): Promise<CmsTranslationFormBodyType | null> => {
        try {
            return await apiCommon.createCmsTranslation.run({ data: cmsTranslationForm });
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    @action public handleEditApiCall = async (
        cmsTranslationForm: TranslationFormType,
        id: number
    ): Promise<CmsTranslationFormBodyType | null> => {
        const data = {
            translation: {
                ...cmsTranslationForm,
            },
        };

        try {
            return await apiCommon.updateCmsTranslation.run({ data: data, id });
        } catch (error) {
            console.error(error);
            return null;
        }
    }; // make generic - currently only good for promo carousel

    @action public handleDeleteApiCall = async (id: number): Promise<void> => {
        try {
            await apiCommon.deleteCmsTranslation.run({ id });
        } catch (error) {
            console.error(error);
        }
    };
}
